import { APP_ROUTES } from 'constants/routes';
import { uuidSegmentUnder } from 'utils/uuidPathSegment';

import { isDistributorPath } from './distributorContext';

/**
 * The order `refId` a `/orders/sales-orders/<segment>` URL names, or `null`
 * when the URL is a listing (All, a registered distributor, or an unported
 * sub-page). Shape-decided inside the distributor splat — see
 * `uuidSegmentUnder` for why there is no `:orderId` route.
 */
export function orderRefIdFromSalesOrdersPath(pathname: string): string | null {
  if (isDistributorPath(pathname)) return null;
  return uuidSegmentUnder(APP_ROUTES.ordersSalesOrdersBase, pathname);
}
